/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Missing_Asset_ErrorInputs */

const en_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to get Asset ID, or Token Id.`)
};

const fr_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'obtenir l'ID d'asset ou l'ID de jeton.`)
};

const de_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-ID oder Token-ID konnten nicht abgerufen werden.`)
};

const it_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile ottenere l'ID risorsa o l'ID token.`)
};

const ru_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось получить идентификатор актива или идентификатор токена.`)
};

const es_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede obtener el ID del activo o el ID del token.`)
};

const zh_cn2_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法获取资产 ID 或代币 ID。`)
};

const ja_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセット ID またはトークン ID を取得できません。`)
};

const hi_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसेट आईडी या टोकन आईडी प्राप्त करने में असमर्थ।`)
};

const pt_pt2_iconik_import_missing_asset_error = /** @type {(inputs: Iconik_Import_Missing_Asset_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível obter o ID do ativo ou o ID do token.`)
};

/**
* | output |
* | --- |
* | "Unable to get Asset ID, or Token Id." |
*
* @param {Iconik_Import_Missing_Asset_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_missing_asset_error = /** @type {((inputs?: Iconik_Import_Missing_Asset_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Missing_Asset_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_missing_asset_error(inputs)
	if (locale === "de") return de_iconik_import_missing_asset_error(inputs)
	if (locale === "it") return it_iconik_import_missing_asset_error(inputs)
	if (locale === "ru") return ru_iconik_import_missing_asset_error(inputs)
	if (locale === "es") return es_iconik_import_missing_asset_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_missing_asset_error(inputs)
	if (locale === "ja") return ja_iconik_import_missing_asset_error(inputs)
	if (locale === "hi") return hi_iconik_import_missing_asset_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_missing_asset_error(inputs)
	return en_iconik_import_missing_asset_error(inputs)
});